import React from "react";
import HomeServices from "../Components/Home/HomeServices";
import {
  Wrench,
  Flame,
  Zap,
  Microwave,
  Utensils,
  Fan,
  Thermometer,
  Hammer,
  ArrowRight,
  PhoneCall,
  Building,
  Home,
  Factory,
  Paintbrush,
  Ruler,
  HardHat,
  Truck,
  PenTool,
  Shield,
  Layers,
  Briefcase,
  Droplet,
  Sun,
  TreePine,
  BrickWall,
} from "lucide-react";

const services = [
  {
    icon: <Hammer size={28} />,
    title: "RESIDENTIAL CONSTRUCTION",
    desc: "We provide premium residential construction services with best facilities to our clients. These services are provided by our team of professionals in accordance.",
  },
  {
    icon: <Building size={28} />,
    title: "COMMERCIAL BUILDINGS",
    desc: "Our commercial construction services are provided to clients at budget-friendly market prices. These services are provided by our team of professionals in accordance. We also provide complete commercial building solutions to our clients.",
  },
  {
    icon: <Wrench size={28} />,
    title: "INFRASTRUCTURE PROJECTS",
    desc: "We have a team of engineers with the necessary expertise, like project management, quality control and timely delivery in Lokesh Mandal Constructions for all infrastructure projects.",
  },
  {
    icon: <Flame size={28} />,
    title: "RENOVATION SERVICES",
    desc: "We provide renovation and remodeling services with best facilities to our clients. These services are provided by our team of professionals in accordance.",
  },
  {
    icon: <Zap size={28} />,
    title: "INTERIOR DESIGNING",
    desc: "This service includes modern interior design solutions for residential and commercial spaces.",
  },
  {
    icon: <Microwave size={28} />,
    title: "PROJECT MANAGEMENT",
    desc: "End-to-end construction project management including planning, execution, quality assurance, and compliance checks.",
  },
  {
    icon: <Paintbrush size={28} />,
    title: "EXTERIOR DESIGN & FACADE",
    desc: "Our exterior design services include modern facades, cladding, and architectural enhancements that elevate building aesthetics.",
  },
  {
    icon: <Ruler size={28} />,
    title: "STRUCTURAL ENGINEERING",
    desc: "We provide expert structural engineering solutions ensuring safety, durability, and compliance with modern building codes.",
  },
  {
    icon: <HardHat size={28} />,
    title: "SITE MANAGEMENT & SUPERVISION",
    desc: "Our site management services ensure smooth operations, workforce coordination, and safety compliance throughout the project lifecycle.",
  },
  {
    icon: <Truck size={28} />,
    title: "CONSTRUCTION MATERIAL SUPPLY",
    desc: "We supply high-quality construction materials including cement, steel, bricks, aggregates, and other building essentials.",
  },
  {
    icon: <PenTool size={28} />,
    title: "ARCHITECTURAL DESIGN & PLANNING",
    desc: "Our architectural design services bring creativity and functionality together, creating spaces that inspire and endure.",
  },
  {
    icon: <Shield size={28} />,
    title: "QUALITY ASSURANCE & TESTING",
    desc: "Our quality assurance team ensures every project meets rigorous standards, from material selection to final inspection.",
  },
  {
    icon: <Layers size={28} />,
    title: "MULTI-STORY BUILDINGS",
    desc: "We construct high-rise residential and commercial buildings with structural integrity and modern amenities.",
  },
  {
    icon: <Briefcase size={28} />,
    title: "REAL ESTATE DEVELOPMENT",
    desc: "We offer complete real estate development services including land acquisition, planning, construction, and project marketing.",
  },
  {
    icon: <Droplet size={28} />,
    title: "PLUMBING & SANITATION",
    desc: "We provide comprehensive plumbing installations, drainage systems, and sanitation solutions for all construction projects.",
  },
  {
    icon: <Sun size={28} />,
    title: "ELECTRICAL CONTRACTING",
    desc: "Our electrical contracting services include wiring, lighting installations, and modern smart building electrical solutions.",
  },
  {
    icon: <TreePine size={28} />,
    title: "LANDSCAPING & GREEN SPACES",
    desc: "We create beautiful outdoor spaces with gardens, lawns, pathways, and sustainable greenery solutions for properties.",
  },
  {
    icon: <BrickWall size={28} />,
    title: "MASONRY & STRUCTURAL WORK",
    desc: "We specialize in high-quality masonry, brickwork, concrete structures, and load-bearing construction with precision.",
  },
  {
    icon: <Shield size={28} />,
    title: "BUILDING PERMITS & APPROVALS",
    desc: "We handle all legal approvals, permits, and documentation required for construction projects as per government regulations.",
  },
  {
    icon: <PenTool size={28} />,
    title: "3D VISUALIZATION & RENDERING",
    desc: "High-quality 3D designs and walkthroughs to help clients visualize their projects before construction begins.",
  },
  {
    icon: <Ruler size={28} />,
    title: "LAND SURVEYING",
    desc: "Accurate land surveying services to ensure proper planning, measurement, and execution of construction projects.",
  },
  {
    icon: <HardHat size={28} />,
    title: "LABOR CONTRACTING",
    desc: "Skilled and experienced labor workforce provided for all types of construction and infrastructure projects.",
  },
  {
    icon: <BrickWall size={28} />,
    title: "DEMOLITION SERVICES",
    desc: "Safe and controlled demolition of old structures with proper waste management and site clearance.",
  },
  {
    icon: <Droplet size={28} />,
    title: "RAINWATER HARVESTING",
    desc: "Eco-friendly rainwater harvesting systems designed for sustainable water management.",
  },
  {
    icon: <Sun size={28} />,
    title: "SOLAR PANEL INSTALLATION",
    desc: "Installation of solar energy systems for residential and commercial buildings to promote sustainability.",
  },
  {
    icon: <Layers size={28} />,
    title: "PRE-ENGINEERED BUILDINGS (PEB)",
    desc: "Cost-effective and quick-to-install pre-engineered steel building solutions.",
  },
  {
    icon: <TreePine size={28} />,
    title: "ROAD & PAVEMENT WORKS",
    desc: "Construction of internal roads, pavements, parking areas, and site development infrastructure.",
  },
  {
    icon: <Wrench size={28} />,
    title: "RETROFITTING & REINFORCEMENT",
    desc: "Strengthening and upgrading existing structures to improve safety and extend lifespan.",
  },
];

const AllServices = () => {
  return (
    <section className="hob-services-section">
      <div className="hob-services-header">
        <h2 className="hob-services-heading">Our Services</h2>
        <p className="hob-services-subtext">
          We build your dream projects with expert engineers and trusted
          craftsmanship.
        </p>
      </div>
      <div className="hob-services-grid">
        {services.map((service, idx) => (
          <div className="hob-service-card" key={idx}>
            <div className="hob-service-icon">{service.icon}</div>
            <h3 className="hob-service-title">{service.title}</h3>
            <p className="hob-service-desc">{service.desc}</p>
            <div className="hob-service-actions">
              <span
                className="hob-service-link"
                onClick={() => (window.location.href = "tel:70390 34000")}
                style={{ cursor: "pointer" }}
              >
                <PhoneCall size={14} />
                Call Now
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AllServices;
